import React, { useState } from "react";
import { set } from "dot-prop-immutable";
import { toolFormAttr, toolCollapseAttr, getLocale, treeDataSource } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Row, Col, Radio } from '@whalecloud/fdx';
import HeightSetting from '@whalecloud/page-builder-base-components/components/ElementSettings/HeightSetting';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import StaticSettings from './StaticSettings';
import RemoteSettings from './RemoteSettings';

const { Panel } = Collapse;
const valueKey = 'data.formItemSettings';

const TreeSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;
  const [dataMode, setDataMode] = useState('static')

  const handleChange = (e: any) => {
    setDataMode(e.target.value)
  }

  const {
    autoInitialize,
  } = formItemSettings;

  const initialValues = {
    autoInitialize,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const newElement = set(element, propName, obj[key]);

      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <CommonItemSettings defaultValueHide allowClearHide />
        <HeightSetting />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_AUTO_INITILIZE']} name="autoInitialize" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_FORM_TABS_OPTIONS']} key="2">
        <Row gutter={8}>
          <Col span={24} align="center">
            <Radio.Group buttonStyle="solid" size="small" value={dataMode} onChange={handleChange}>
              <Radio.Button value="static">{messages['PAGEBUIDER_SETTINGS_DATASOURCE_STATIC']}</Radio.Button>
              <Radio.Button value="remote">{messages['PAGEBUIDER_SETTINGS_DATASOURCE_REMOTE']}</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        <Row className="my-4">
          <Col span={24}>
            {
              dataMode === 'static' && <StaticSettings treeData={treeDataSource} element={element} updateElement={updateElement} />
            }
            {
              dataMode === 'remote' && <RemoteSettings element={element} updateElement={updateElement} />
            }
          </Col>
        </Row>
      </Panel>
    </Collapse>
  );
};
export default TreeSettings;
